module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/WhyNeedSection/theft-d4dbdc3eee8fc6486f42eea4f3f06c86.png";